"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBJECT_RISK_CATEGORIES = void 0;
exports.default = getSubjectByRiskCategories;
var SUBJECT_RISK_CATEGORIES = exports.SUBJECT_RISK_CATEGORIES = ['At Risk', 'Needs Improvement', 'On Track', 'Not Enough Data'];
function getSubjectByRiskCategories(riskData) {
  if (!riskData) {
    return null;
  }
  var data = {
    'On Track': [],
    'Not Enough Data': [],
    'At Risk': [],
    'Needs Improvement': []
  };
  var subjectsRisk = riskData.get('subject_level_risks');
  subjectsRisk.forEach(function (subject) {
    switch (subject.riskCategory) {
      case 'On_Track':
        data['On Track'].push(subject.subjectId);
        break;
      case 'Needs_Improvement':
        data['Needs Improvement'].push(subject.subjectId);
        break;
      case 'At_Risk':
        data['At Risk'].push(subject.subjectId);
        break;
      default:
        // 'Not Enough Data'
        data['Not Enough Data'].push(subject.subjectId);
    }
  });
  return data;
}